import React, { Component } from "react";
import Helmet from "react-helmet";
import ContactFind from "../components/Contact/ContactFind";
import config from "../../data/SiteConfig";
import Header from "../components/Header/Header";
import Clear from "../components/Structure/Clear";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import HeaderPage from "../components/Header/HeaderPage";
import Footer from "../components/Footer/Footer";
import picture from "./img/contact.jpg";
import Menu from "../components/Menu/Menu";

class Ws extends Component {
  render() {
    const { slug } = this.props.pathContext;

    let title = "Stage Web designer (H/F)";
    let description = "Web & Mobile UI/UX";
    let goto = "";

    const postNode = {
        "frontmatter": {
            "title": title,
            "description": "Venez sublimer vos créations !",
            "cover": picture
        }
    };

    return (
        <div className="contact">
            <Helmet title={title} />
            <SEO postPath={slug} postNode={postNode} postSEO />
            <Menu />
            <Header />
            <HeaderPage title={title} description={description} picture={picture} />
            <article className="container row-bottom-padded-md row-top-padded-md">
                <div className="col-md-12">

                    <h2>Qui sommes nous ?</h2>
                    <p>Integral Service est un studio Web rattaché à la société Integral System (2003) spécialisée dans la réalisation d'application Web et mobile sur-mesure.
                    </p>
                    <p>Nos derniers projets palpitants en date sont la création d'un jeu de simulation de gestion de société pour la société IPAJE, la création d'un site E-Commerce éphémère pour Michelin, la réalisation d'une application métier pour les 3000 infirmières du groupe Synlab Labco ou encore la réalisation d'un réseau social pour les compositeurs de musique, sans parler des portails pour Emmaüs</p>
                    <p>C'est dans ce cadre de croissance et d'intégration de nouvelles offres que nous recherchons un ou une <strong>Web designer</strong> pour rejoindre notre équipe web et mobile.</p>
                    <h2>Mission</h2>
                    <p>Vous travaillez en collaboration avec les équipes de développement actuellement en place sur de nombreux sujets passionnants:</p>
                    <ul>
                        <li>Design d'applications mobile hybride et Web Apps / <a href="/quest-ce-quune-progressive-web-app" title="Progressive web apps" target="_blank">Porgressive Web apps</a></li>
                        <li>Refonte graphiques des sites de la société</li>
                    </ul>
                    <p>le tout dans une ambiance d'entraide et partage de connaissance au sein des équipes, pour des projets internes ou projets client encore plus passionnant !</p>
                    
                    <h2>Profil</h2>
                    <ul>
                        <li>Une vraie volonter d'innover dans la réalisation d'interface utilisateur</li>
                        <li>Une passion pour tout ce qui entoure le web et le mobile</li>
                    </ul>
<p>
Vous avez un super esprit d'équipe, un bon relationnel, vous êtes dynamique, savez travailler de façon autonome et êtes doté d'une bonne capacité d'écoute.
</p>
                   
                    <div className="col-md-12 p-3 d-flex justify-content-center">
                         <a  href="/contact" title="Postuler pour l'offre de développeur Symfony PHP"><button className="btn btn-primary">Postuler</button></a>
                    </div>
                    
                </div>
            </article>
            <Clear />
            <Footer />
        </div>
    );
  }
}

export default Ws;



// WEBPACK FOOTER //
// ./src/pages/web-designer-offre-emploi.jsx